import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../hooks/useToast.tsx';
import { authApi } from '../services/api';
import { User, Lock, Save } from 'lucide-react';

export function PerfilPage() {
  const { user, checkAuth } = useAuth();
  const { success, error } = useToast();
  const [nome, setNome] = useState(user?.nome || '');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => { setNome(user?.nome || ''); }, [user]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMsg('');
    if (!nome.trim()) { setMsg('Nome é obrigatório'); return; }
    if (newPassword && newPassword !== confirmPassword) { setMsg('Nova password não coincide com confirmação'); return; }
    if (newPassword && newPassword.length < 6) { setMsg('Nova password deve ter pelo menos 6 caracteres'); return; }
    if (newPassword && !currentPassword) { setMsg('Indique a password atual para alterar'); return; }

    setSaving(true);
    try {
      const response = await authApi.updatePerfil({
        nome: nome.trim(),
        currentPassword: currentPassword || undefined,
        newPassword: newPassword || undefined,
      });
      if (!response.success) throw new Error(response.message || 'Erro ao atualizar perfil');
      success('Perfil atualizado com sucesso');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      await checkAuth();
    } catch (err: unknown) {
      const m = err instanceof Error ? err.message : 'Erro ao atualizar perfil';
      setMsg(m);
      error(m);
    } finally { setSaving(false); }
  };

  return (
    <div className="page-container" style={{ maxWidth: 560 }}>
      <div className="page-header"><h1 className="page-title">Meu Perfil</h1></div>
      <div className="card" style={{ padding: 24 }}>
        <form onSubmit={handleSubmit} noValidate>
          {msg && <div className="form-error" role="alert">{msg}</div>}
          <div className="form-group">
            <label className="label">Nome de utilizador</label>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <User className="w-5 h-5" style={{ color: 'var(--c-text-muted)' }} />
              <input className="input" value={nome} onChange={e => setNome(e.target.value)} placeholder="Nome" required />
            </div>
          </div>
          <div style={{ height: 1, background: 'var(--c-border)', margin: '18px 0' }} />
          <p style={{ fontSize: 13, color: 'var(--c-text-muted)', marginBottom: 12 }}>Alterar password (opcional)</p>
          <div className="form-group">
            <label className="label">Password atual</label>
            <input type="password" className="input" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} placeholder="••••••" autoComplete="current-password" />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="label">Nova password</label>
              <input type="password" className="input" value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder="Nova password" autoComplete="new-password" />
            </div>
            <div className="form-group">
              <label className="label">Confirmar</label>
              <input type="password" className="input" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Confirmar" autoComplete="new-password" />
            </div>
          </div>
          <button type="submit" className="btn btn-primary" disabled={saving} style={{ marginTop: 8 }}>
            <Save className="w-4 h-4" />{saving ? 'A guardar...' : 'Guardar alterações'}
          </button>
          <div style={{ marginTop: 16, fontSize: 12, color: 'var(--c-text-subtle)', display: 'flex', alignItems: 'center', gap: 6 }}>
            <Lock className="w-4 h-4" /> {user?.role} • {user?.ativo ? 'Ativo' : 'Inativo'}
          </div>
        </form>
      </div>
    </div>
  );
}
